import React from 'react';
import ImageUploader from './ImageUploader';
import spinner from '../images/spinner.gif';
import '../App.css';

export default class ItemEditor extends React.Component {

  constructor(props) {
    super(props);
    if (this.props.item) {
      // Editing an existing item..
      this.state = {
        itemId: this.props.item._id.$oid,
        itemName: this.props.item.name,
        itemDescription: this.props.item.description,
        itemSerial: this.props.item.serial,
        itemAssetTag: this.props.item.asset_tag,
        itemLabels: this.props.item.labels,
        itemValue: this.props.item.value,
        itemPrivate: this.props.item.private,
      }
    } else {
      this.state = {
        itemName: this.props.itemName,
        itemDescription: this.props.itemDescription,
        itemSerial: this.props.itemSerial,
        itemAssetTag: this.props.itemAssetTag,
        itemLabels: this.props.itemLabels,
        itemValue: this.props.itemValue,
        itemPrivate: this.props.itemPrivate,
      };
    }
  }

  updateItemName(data) {
    this.setState({itemName: data});
  }

  updateItemDescription(data) {
    this.setState({itemDescription: data});
  }

  updateItemSerial(data) {
    this.setState({itemSerial: data});
  }

  updateItemAssetTag(data) {
    this.setState({itemAssetTag: data});
  }

  updateItemValue(data) {
    this.setState({itemValue: data});
  }

  updateItemPrivate(data) {
    // Note that this one is a checkbox.
    this.setState({itemPrivate: data});
  }

  showBody() {
    if (!this.state.childVisible || this.state.childVisible === false) {
      this.setState({
        placeHolder: 'Nome',
        childVisible: true,
      });
    }
  }

  showImageUploader() {
    this.setState({showImageUploader: true});
  }

  hideImageUploader() {
    if (this._imageUploader) {
      this._imageUploader.setState({binFile: undefined});
    }
    this.setState({showImageUploader: false});
  }

  deleteItem() {
    // let url = window.location.protocol + '//' + window.location.host;
    // url = `${url}/api/v1/users/${this.props.user._id.$oid}/items/${this.props.item._id.$oid}`;
    let url = `/api/v1/users/${this.props.user._id.$oid}/items/${this.props.item._id.$oid}`;
    let reqData = {uri: url, method: 'DELETE'};
    let that = this;
    try {
      fetch(reqData.uri, reqData, function(err, data) {
        if (err) {
          console.log('Error submitting new item!: ' + err);
        }
        if (data && data.statusCode !== 429) {
          let itemUser = that.props.user;
          itemUser.inventory = itemUser.inventory.filter(item => item._id.$oid !== that.props.item._id.$oid);
          that.props.viewPage.setState({showItemEditor: false, editingItem: undefined});
        }
      });
    } catch(e) {
      console.log('ERROR DELETING ITEM!' + e);
    }
  }

  submitItem(e) {
    e.preventDefault();
    let name = this.state.itemName || '';
    let description = this.state.itemDescription || '';
    let value = this.state.itemValue;
    let serial = this.state.itemSerial || '';
    let assetTag = this.state.itemAssetTag || '';
    let labels = this.state.itemLabels || [];
    let itemPrivate = this.state.itemPrivate ? 'true' : 'false';
    // let url = window.location.protocol + '//' + window.location.host;
    // url = `${url}/api/v1/users/${this.props.user._id.$oid}/items`;
    let url = `/api/v1/users/${this.props.user._id.$oid}/items`;
    if (this.props.item) {
      url += `/${this.props.item._id.$oid}`;
    }
    let reqData = {
      uri: url,
      method: this.props.item ? 'PUT' : 'POST'
    };
    let that = this;
    let imageUploader = this._imageUploader || this.imageUploader;
    let formData = new FormData();
    formData.append('item[name]', name);
    formData.append('item[description]', description);
    formData.append('item[asset_tag]', assetTag);
    formData.append('item[private]', itemPrivate);
    formData.append('item[serial]', serial);
    if (imageUploader && imageUploader.state && imageUploader.state.binFile && imageUploader.state.binFile.toDataURL) {
      let uploadedStringImage = imageUploader.state.binFile.toDataURL();
      let imgBuf = new Buffer(uploadedStringImage.replace(/^data:image\/\w+;base64,/, ""),'base64');
      formData.append('item[image]', imgBuf, 'image.png');
      reqData.body = formData;
      reqData.headers = {'Content-Type': 'multipart/form-data'};
      // reqData['headers'] = {'content-type': 'multipart/form-data'};
      // reqData['multipart'] = {'data': mdata};
    }
    if (value) {
      formData.append('item[value]', value);
    }
    if (labels) {
      formData.append('item[labels]', labels);
    }
    reqData.body = formData;
    try {
      // this.setState({showSpinner: true});
      fetch(reqData.uri, reqData, function(err, data) {
        if (err) {
          console.log('Error submitting new item!: ' + err);
        }
        if (data && data.statusCode !== 429) {
          console.log('[ITEM] Got data from item: ' + data.body);
          let jsonBody = JSON.parse(data.body);
          let itemUser = that.props.user;
          if (that.props.item) {
            // this is an update.
            for (let i = 0; i < itemUser.inventory.length; i++) {
              let checkItem = itemUser.inventory[i];
              if (checkItem._id.$oid === that.props.item._id.$oid) {
                itemUser.inventory[i] = jsonBody['items'];
              }
            }
          } else {
            itemUser.inventory ? itemUser.inventory.push(jsonBody['items']) : itemUser.inventory = [jsonBody['items']];
          }
          that.props.viewPage.setState({showItemEditor: false, editingItem: undefined});
        }
      });
    } catch(e) {
      console.log('Item creation error: ' + e);
    }
  }

  clearState(e) {
    if (e) e.preventDefault();
    console.log('Clear state has been called!');
    this.setState({showSpinner: false, placeHolder: '', childVisible: '', itemName: '', itemDescription: '', itemValue: '', itemLabels: [], itemAssetTag: '', itemSerial: ''});
    this.imageUploader = undefined;
    this.props.viewPage.setState({showItemEditor: false, editingItem: undefined});
  }

  render() {
    let placeHolder = this.props.placeHolder || this.state.placeHolder || 'Nome de item de inventário',
        itemDescriptionInput = <div className='postBodyInputDiv'>
          <textarea className='postBodyInputInput' rows={6} size={8}
               onChange={(e) => this.updateItemDescription(e.target.value)}
               value={this.state.itemDescription || ''} />
          <br />
        </div>, finalImageFile = undefined;
          // <input type='submit' value='Item' />
    if (this._imageUploader) {
      if (this._imageUploader.state && this._imageUploader.state.binFile) {
        try {
          finalImageFile = this._imageUploader.state.binFile.toDataURL();
        } catch(e) {
          console.log('Unable to call data URL on image... Canceled?');
        }
      }
    } else if (this.imageUploader) {
      if (this.imageUploader.state && this.imageUploader.state.binFile) {
        try {
          finalImageFile = this.imageUploader.state.binFile.toDataURL();
        } catch (e2) {
          console.log('Unable to call data URL on image... Canceled?');
        }
      }
    }
    if (!finalImageFile && this.state.imageFile) {
      // Image URL got passed in from props.
      if (typeof(this.state.imageFile) === 'string') {
        if (this.state.imageFile.indexOf('missing.png') === -1) {
          finalImageFile = this.state.imageFile;
        }
      } else {
        finalImageFile = this.state.imageFile;
      }
    }
    if (this._imageUploader && !this.imageUploader) {
      this.imageUploader = this._imageUploader;
    }
    let cancelButton = <input className='postCancelButton' onClick={(e) => this.clearState(e)} type='button' value='Cancelar' />;
    let itemEditorButtons = <div className='postSubmitButtonDiv'>
        {cancelButton}
        <input className='postCameraButton' onClick={() => this.showImageUploader()} type='button' value='Imagem' />
        <input className='postSubmitButton' type='submit' value='Salvar' />
        { this.state.showImageUploader ? <ImageUploader finish={this.hideImageUploader.bind(this)} ref={(ref) => this._imageUploader = ref}  /> : '' }
        { finalImageFile ? <div className='itemImagePreview'><img src={finalImageFile} alt='preview' width={100} /></div> : '' }
    </div>;
    let image = '';
    if (this.props && this.props.item && this.props.item.image) {
      // TODO - Is this necessary at all?
      image = <img className='avatar' src={this.props.item.image} alt={this.props.item.name} />;
    }
    let checked = (this.state.itemPrivate === 'true' || this.state.itemPrivate === true) ? true : false;
    return (
      <div className='postCreator' style={{'min-height': '200px'}}>
        <form onSubmit={(e) => this.submitItem(e)}>
          <div onClick={this.showBody.bind(this)}>
            <div className='itemNameInputDiv'>
              {image}
              Nome: <input className='itemNameInputInput' placeholder={placeHolder} type='text' onClick={(e) => this.setState({placeHolder: 'Name'})}
                     onChange={(e) => this.updateItemName(e.target.value)} value={this.props.itemName || this.state.itemName || ''} />
            </div>
            <div className='itemNameInputInput'>
              Serial: <input className='itemNameInputInput' placeholder='Serial' type='text'
                     onChange={(e) => this.updateItemSerial(e.target.value)} value={this.props.itemSerial || this.state.itemSerial || ''} />
            </div>
            <div className='itemNameInputInput'>
              Asset Tag: <input className='itemNameInputInput' placeholder='Asset Tag' type='text'
                     onChange={(e) => this.updateItemAssetTag(e.target.value)} value={this.props.itemAssetTag || this.state.itemAssetTag || ''} />
            </div>
            <div className='itemNameInputInput'>
              Valor: <input className='itemNameInputInput' placeholder='Valor' type='text'
                     onChange={(e) => this.updateItemValue(e.target.value)} value={this.props.itemValue || this.state.itemValue || ''} />
            </div>
            <div className='itemNameInputInput'>
              Private: <input className='itemNameInputInput'  type='checkbox' checked={checked}
                     onChange={(e) => this.updateItemPrivate(e.target.checked)} value={this.props.itemPrivate || this.state.itemPrivate || ''} />
            </div>
          </div>

          { ( this.props.body || this.state.childVisible ) ? itemDescriptionInput : '' }
          { this.state.showSpinner ? <img src={spinner} alt='' style={{'position': 'fixed', 'marginLeft': '160px'}}/> : ''}

          { !this.state.childVisible ? cancelButton : '' }
          { (this.props.item && !this.state.childVisible) ? <input type='button' value='Delete' className='postCancelButton'
                                                             onClick={() => {if(window.confirm('Delete ' + this.props.item.name + '?')) this.deleteItem()}} /> : ''}

          { (this.state.childVisible || this.props.itemName) ? itemEditorButtons : '' }


        </form>
      </div>
    );
  }
}
